import { render, staticRenderFns } from "./boardWithdrawn.vue?vue&type=template&id=66afc270&scoped=true"
import script from "./boardWithdrawn.vue?vue&type=script&lang=js"
export * from "./boardWithdrawn.vue?vue&type=script&lang=js"
import style0 from "./boardWithdrawn.vue?vue&type=style&index=0&id=66afc270&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66afc270",
  null
  
)

export default component.exports